/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSortFilterRemove: {
  name: 'sort-filter-remove';
  data: string;
} = {
  name: 'sort-filter-remove',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.003 3C3.478 3 2.514 4.638 3.255 5.971l4.048 7.288V16.5a2 2 0 0 0 .8 1.6l2 1.5c1.319.989 3.2.048 3.2-1.6v-4.74l4.05-7.289C18.092 4.638 17.128 3 15.602 3h-10.6Zm4.049 9.288L5.002 5h10.602l-4.049 7.288a2 2 0 0 0-.252.971V18l-2-1.5v-3.24a2 2 0 0 0-.251-.972Zm7.655 2.005a1 1 0 0 0-1.414 1.414l1.793 1.793-1.793 1.793a1 1 0 0 0 1.414 1.414l1.793-1.793 1.793 1.793a1 1 0 0 0 1.414-1.414L19.914 17.5l1.793-1.793a1 1 0 0 0-1.414-1.414L18.5 16.086l-1.793-1.793Z" fill="currentColor"/></svg>`,
};
